import styled from 'styled-components'

export const NotificationsCount = styled.span`
  background-color: var(--red);
  height: 1rem;
  padding: 0.15rem;
  margin-left: -0.5rem;
  margin-top: -1rem;
`
